export function generateRandomId() {
  return (Math.random() * 1000000) | 0;
}
